"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { meetings: [] };
    },
    onMount: function () {
        this.fetchMeetings();
    },
    onOpenSession: function (type, provider, id) {
        window.Extensions.run(provider, {
            body: {
                type,
                id
            }
        });
    },
    fetchMeetings: async function () {
        try {
            const {error, message, sessions, more} = await Request('/livesession/list');
            if (error)
                throw new Error(message);
            this.state.meetings = sessions || [];
        } catch (error) {
            console.log('Error Fetching Meetings: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/components/MyMeetings.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Schedules_template = require("../../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Switch_template = require("../../../../../components/Switch/index.marko"),
    Switch_tag = marko_loadTag(Switch_template),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_attrs0 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs1 = {
        "class": "cursor-pointer text-center"
      },
    marko_attrs2 = {
        "class": "cursor-pointer"
      },
    marko_attrs3 = {
        "class": "font-medium-3"
      },
    marko_attrs4 = {
        "class": "text-ellipsis-2 text-muted"
      },
    marko_attrs5 = {
        "class": "badge badge-success"
      },
    marko_attrs6 = {
        "class": "text-success"
      },
    marko_attrs7 = {
        "class": "border border-color-danger text-danger rounded px-50 px-25 font-small-3"
      },
    marko_attrs8 = {
        "class": "mx-1 my-2",
        id: "meetings"
      },
    marko_attrs9 = {
        "class": "card"
      },
    marko_attrs10 = {
        "class": "list-group"
      },
    marko_attrs11 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_SessionItem(out, { sessionId, type, provider, topic, description, status, schedules, created, updated }) {
    out.be("li", marko_attrs0, "0", component);

    Row_tag({
        class: "d-flex align-items-center",
        col: [
            {
                ns: "col-md-1 col-2",
                qs: "col-1",
                hs: "col-2",
                renderBody: function(out) {
                  out.be("div", marko_attrs1, "3", component, null, 0, {
                      onclick: __component.d("click", "onOpenSession", false, [
                          type,
                          provider.type,
                          sessionId
                        ])
                    });

                  Image_tag({
                      alt: topic,
                      src: window.Extensions.meta(provider.type).favicon,
                      style: "width:40px;height:40px"
                    }, out, __component, "4");

                  out.ee();
                }
              },
            {
                renderBody: function(out) {
                  Row_tag({
                      class: "no-gutters d-flex align-items-center",
                      col: [
                          {
                              ns: "col-md-5 col-12",
                              qs: "col",
                              hs: "col-7",
                              renderBody: function(out) {
                                out.e("div", marko_attrs2, "8", component, 2, 0, {
                                    onclick: __component.d("click", "onOpenSession", false, [
                                        type,
                                        provider.type,
                                        sessionId
                                      ])
                                  })
                                  .e("span", marko_attrs3, "9", component, 1)
                                    .t(topic, component)
                                  .e("div", marko_attrs4, "10", component, 1)
                                    .t(description, component);
                              }
                            },
                          {
                              ns: "col-md-4 col-6",
                              qs: "col-4",
                              hs: "col-5",
                              renderBody: function(out) {
                                const calendar = schedules.length ? 
                                                          schedules.map( ({ start, end }) => { 
                                                              return { 
                                                                start: { date: formatDate( start, 'calendar' ) }, 
                                                                end: { date: formatDate( end, 'calendar' ) } 
                                                              } 
                                                          } )
                                                          : [{ start: { date: formatDate( updated ? updated.at : created.at, 'calendar' ) } }]

                                Schedules_tag({
                                    list: calendar,
                                    clickable: true
                                  }, out, __component, "12");
                              }
                            },
                          {
                              class: "col-3 text-right",
                              renderBody: function(out) {
                                Switch_tag({
                                    by: status,
                                    case: [
                                        {
                                            is: "active",
                                            renderBody: function(out) {
                                              out.be("span", marko_attrs5, "16", component);

                                              Locale_tag({
                                                  text: "New"
                                                }, out, __component, "17");

                                              out.ee();
                                            }
                                          },
                                        {
                                            is: "completed",
                                            renderBody: function(out) {
                                              out.be("span", marko_attrs6, "19", component);

                                              Locale_tag({
                                                  text: "Completed"
                                                }, out, __component, "20");

                                              out.ee();
                                            }
                                          }
                                      ],
                                    default: {
                                        renderBody: function(out) {
                                          out.be("span", marko_attrs7, "22", component);

                                          Locale_tag({
                                              text: status.toUpperCase()
                                            }, out, __component, "23");

                                          out.ee();
                                        }
                                      }
                                  }, out, __component, "14");
                              }
                            }
                        ]
                    }, out, __component, "6");
                }
              }
          ]
      }, out, __component, "1");

    out.ee();
  }

  if (state.meetings.length) {
    out.be("section", marko_attrs8, "24", component);

    out.be("h6", null, "25", component);

    Locale_tag({
        text: "You have some Live Sessions"
      }, out, __component, "26");

    out.ee();

    out.be("div", marko_attrs9, "27", component);

    out.be("ul", marko_attrs10, "28", component);

    const displayLimit = state.meetings.length > 3 ? 2 : state.meetings.length - 1

    var $for$0 = 0;

    marko_forRange(0, displayLimit, 1, function(index) {
      var $keyScope$0 = "[" + (($for$0++) + "]");

      marko_dynamicTag(out, macro_SessionItem, function() {
        return state.meetings[index];
      }, null, null, null, __component, "32" + $keyScope$0);
    });

    if ((state.meetings.length - 1) > displayLimit) {
      out.be("li", marko_attrs11, "29", component);

      route_link_tag({
          href: "/live-sessions?type=active",
          class: "d-block text-right",
          renderBody: function(out) {
            Locale_tag({
                text: "View all",
                class: "text-primary"
              }, out, __component, "31");
          }
        }, out, __component, "30");

      out.ee();
    }

    out.ee();

    out.ee();

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
